import { authenticatedRequest } from './authApi';
import { REST_API_ORIGIN } from '../platform/endpoints';

const API_BASE = REST_API_ORIGIN;
export const DISCOVERY_RETURNED_BOUND = 10;

function isObjectId(value) {
  return /^[a-f\d]{24}$/i.test(String(value || ''));
}

function text(value, max = 160) {
  return typeof value === 'string' ? value.trim().slice(0, max) : '';
}

function safeCandidate(value) {
  const user = value?.user || {};
  if (!isObjectId(user._id)) return null;
  return {
    user: {
      _id: String(user._id),
      fullName: text(user.fullName, 80),
      username: text(user.username, 80),
      avatarUrl: text(user.avatarUrl, 1024),
      photoPath: text(user.photoPath, 1024),
      photo: text(user.photo, 1024),
      zodiacSign: text(user.zodiacSign, 40),
    },
    rank: Math.max(1, Math.min(DISCOVERY_RETURNED_BOUND, Number(value.rank) || 1)),
    relevanceBucket: ['low', 'medium', 'high'].includes(value?.relevanceBucket) ? value.relevanceBucket : 'low',
    reasonCodes: Array.isArray(value?.reasonCodes) ? value.reasonCodes.slice(0, 5).map((code) => text(code, 64)) : [],
  };
}

export function validateDiscoveryResponse(payload) {
  if (!payload?.ok || typeof payload.policyVersion !== 'string') throw new Error('recommendation_unavailable');
  const candidates = (Array.isArray(payload.candidates) ? payload.candidates : []).map(safeCandidate).filter(Boolean).slice(0, DISCOVERY_RETURNED_BOUND);
  return {
    policyVersion: payload.policyVersion.slice(0, 64),
    candidates,
    recommendationSession: text(payload.recommendationSession, 4096),
  };
}

export async function getUserDiscovery() {
  const response = await authenticatedRequest(`${API_BASE}/api/recommendations/users/shadow?limit=${DISCOVERY_RETURNED_BOUND}`, {
    method: 'GET',
    diagSource: 'userDiscoveryApi',
  });
  return validateDiscoveryResponse(response);
}

export async function recordUserDiscoveryExposure({ exposureSessionId, recommendationSession, policyVersion, candidateIds }) {
  const response = await authenticatedRequest(`${API_BASE}/api/recommendations/users/exposures`, {
    method: 'POST',
    body: { exposureSessionId, recommendationSession, policyVersion, candidateIds },
    diagSource: 'userDiscoveryApi',
  });
  return { ok: response?.ok === true, recorded: Number(response?.recorded || 0) };
}
